import React from 'react';
import { Tag } from 'antd';
import { RiskLevel } from '../types';
import { WarningOutlined, ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';

interface RiskLevelBadgeProps {
  level?: RiskLevel;
}

const RISK_CONFIG: Record<RiskLevel, { color: string; icon: React.ReactNode; text: string }> = {
  low: {
    color: 'success',
    icon: <CheckCircleOutlined />,
    text: 'Low Risk',
  },
  medium: {
    color: 'warning',
    icon: <WarningOutlined />,
    text: 'Medium Risk',
  },
  high: {
    color: 'error',
    icon: <ExclamationCircleOutlined />,
    text: 'High Risk',
  },
};

export const RiskLevelBadge: React.FC<RiskLevelBadgeProps> = ({ level }) => {
  if (!level) return null;

  const config = RISK_CONFIG[level];

  return (
    <Tag color={config.color} icon={config.icon}>
      {config.text}
    </Tag>
  );
};

export default RiskLevelBadge;
